import React, {ComponentType} from "react";
import TimeSlotMessaging from "./index";
import {IProps, IServices, IHandlers, IContainerProps} from './types';

/**
* Gets the interface types as array of strings so we don't need hand code them each time (and reduces chance for mistakes).
*/
import {keys} from 'ts-transformer-keys';
import {hot} from "react-hot-loader";
import ReactUtilsService from "app/services/reactUtils.service";
import AdminService from "external-services/diary-admin-service/admin.service";
import { IDiaryVenue } from "shared-types/index";

const NS = 'TimeSlotMessagingContainer';

const propsKeys: string[] = keys<IProps>();
const containerPropsKeys: string[] = keys<IContainerProps>();
const servicesKeys: string[] = keys<IServices>();

const ThemeWrap = function(all: IProps & IHandlers & IServices) {
  const props: IProps = ReactUtilsService.getObjectByKeys(all, propsKeys) as IProps;
  const {
    warningMsgs, bookingType, errorMsgs, noTables, timeIsOpen, notWalkinBookingMethod,
    handleStandbyBtn, handleWaitListBtn, showRemoveWaitList
  }: IContainerProps = ReactUtilsService.getObjectByKeys(all, containerPropsKeys) as IContainerProps;

  const venue: IDiaryVenue = AdminService.getVenue();
  props.warningMsgs = warningMsgs;
  props.errorMsgs = errorMsgs;
  props.bookingType = bookingType;
  props.noTables = noTables;
  props.timeIsOpen = timeIsOpen;
  props.notWalkinBookingMethod = notWalkinBookingMethod;
  props.isStandbyListEnabled = venue.standByList || false;
  props.hasPaid = props.hasPaid;
  props.showRemoveWaitList = showRemoveWaitList;

  /**
   * Handlers used to modify app state (via a service) from within the module's container.
   * Similar to redux mapDispatchToProps.
   */
  const handlers: IHandlers = {
    handleStandbyBtn, handleWaitListBtn
  }

  return ReactUtilsService.containerWrap(
    <TimeSlotMessaging {...props} {...handlers} />
  );
}

/**
 * Returns properties needed for rendering react2angular
 */
export const R2ATimeSlotMessaging: [ComponentType<unknown>, never[]?, string[]?] = [
  hot(module)(ThemeWrap) as ComponentType<unknown>,
  [...containerPropsKeys] as never[],
  servicesKeys
];
